import { useLocation } from 'react-router';

import { useConfig } from '#/hooks/useConfig';
import { useIsPhone } from '#/hooks/useResponsiveValue';
import { Path } from '#/service/routes';

interface RegistrationBackground {
  registrationBackgroundImage?: string;
  shouldBlockGeneralBackground: boolean;
}

/**
 * Hook to get the background image specific to the registration page if it's configured
 * and the route and form factor conditions are met.
 */
export const useRegistrationBackground = (): RegistrationBackground => {
  const { pathname } = useLocation();
  const { featureConfig } = useConfig();
  const isPhone = useIsPhone();

  const isOnRegistrationPage = pathname === Path.Registration;
  const configuredImage =
    featureConfig.authentication?.standard?.registration?.backgroundImage;

  const registrationBackgroundImage =
    !!configuredImage && isOnRegistrationPage && !isPhone
      ? configuredImage
      : undefined;

  // if registration background is configured, but not shown because of form factor,
  // it should still prevent the general background image showing behind the registration page.
  const shouldBlockGeneralBackground =
    !!configuredImage && isOnRegistrationPage && isPhone;

  return {
    registrationBackgroundImage,
    shouldBlockGeneralBackground,
  };
};
